let held: string | null = null;

/**
 * The account this page was built for, which every API request names
 * (`X-Toado-Account`, in `apiClient.ts`).
 *
 * The session cookie is shared by every tab, so somebody signing in as another
 * account in one tab puts their session under every other tab's requests, and
 * nothing in those pages would notice: one left open on Alice's work would save
 * it as Bob, and an OAuth consent shown to Alice would grant Bob's account. The
 * server does not let a session answer for a page built for another account
 * (`authPreHandler`), so that request is answered 401 and the page reloads as
 * whoever is signed in now (review of 0.2.0, 3 Oct). Enforced there because a
 * page cannot be relied on to notice: a tab the browser froze, a reload
 * somebody cancelled, or a page on its way out after a 401 all go on sending.
 *
 * A page holds one account for its whole life, the first it is given
 * (`AuthProvider` reloads rather than take another); a signed-out page names
 * none.
 */
export function holdPageAccount(userId: string): void {
  held ??= userId;
}

/** The account this page was built for, or null for a page that has held none. */
export function pageAccount(): string | null {
  return held;
}
